import { isLatamTenantValue, type Tenant } from '../configuration/tokenHandling/tokenSlice';
import { Category, serviceMap, type UntranslatedServiceItem } from '../data/serviceData';
import { type AppResponse, mapToServiceList } from './appsMapper';
import { isFleetMonitorVisibleForTenant } from './serviceVisibility';

const isLatamService = (id: string) => id.toLowerCase().includes('latam') || id === 'volksblocker';

const isAlwaysVisible = (id: string, service: UntranslatedServiceItem) =>
    service.category === Category.ADMINISTRATION || id === 'performance';

const isFallbackServiceVisibleForTenant = (id: string, service: UntranslatedServiceItem, tenant?: Tenant) => {
    if (service.hidden) {
        return false;
    }

    // Fallback data has no permission information, so these LATAM links cannot be safely shown.
    if (
        isLatamTenantValue(tenant) &&
        (service.category === Category.MARKETPLACE || service.category === Category.CUSTOMERCENTER)
    ) {
        return false;
    }

    if (id === 'fleetmonitor' && !isFleetMonitorVisibleForTenant(tenant)) {
        return false;
    }

    if (isAlwaysVisible(id, service)) {
        return true;
    }

    return isLatamTenantValue(tenant) ? isLatamService(id) : !isLatamService(id);
};

export const fallbackData = (tenant?: Tenant): AppResponse => ({
    items: Object.entries(serviceMap)
        .filter(([id, service]) => isFallbackServiceVisibleForTenant(id, service, tenant))
        .map(([key]) => ({ id: key })),
});

export const fallbackServiceMap = (tenant?: Tenant) => mapToServiceList(fallbackData(tenant));
